import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  titles: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Włącz powiadomienia WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]: 'Automatyczne połączenia o oczekujących zamówieniach',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Godziny otwarcia',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Lokalizacja',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Tożsamość restauracji',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Czas odbioru',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Czas dostawy',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Dane logowania pracowników',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importuj menu',
    [ONBOARDING_GUIDE_STEPS.Favourites]: 'Ulubione',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Wyprzedane produkty',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Kody promocyjne',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Galeria',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]: 'Dodaj logo restauracji i kolor główny',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Zamów ulotki',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Utwórz sklep',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Włącz zamówienia na żywo',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Włącz Google Business',
  },
  descriptions: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Sprawdź, czy właściciel/ osoba kontaktowa ma WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]:
      'Sprawdź, czy numer restauracji jest prawidłowy, aby odbierać automatyczne połączenia i nie przegapić zamówień',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Skonfiguruj godziny otwarcia restauracji',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Skonfiguruj lokalizację restauracji',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Ustaw typ restauracji i kuchnie wyświetlane w sklepie',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Skonfiguruj ustawienia czasu odbioru',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Skonfiguruj ustawienia czasu dostawy',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Skonfiguruj dane logowania personelu',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importuj menu od zewnętrznego dostawcy',
    [ONBOARDING_GUIDE_STEPS.Favourites]:
      'Oznacz 4 pozycje jako ulubione. Zapytaj restaurację, które 4 dania są najpopularniejsze',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Skonfiguruj zachowanie wyprzedanych pozycji',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Skonfiguruj kody promocyjne',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Zaktualizuj galerię',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]:
      'Pobierz logo z restauracji lub jej strony na Lieferando. Zapisz stamtąd logo. Wybierz kolor dominujący w logo restauracji',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Edytuj projekt ulotki i złóż zamówienie',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Utwórz witrynę i edytuj stronę internetową w razie potrzeby',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Włącz zamówienia na żywo („!tylko w dniu uruchomienia!")',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Połącz konto Google Business',
  },
  buttons: {
    mark_as_complete: 'Oznacz jako ukończone',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
  },
};
